<ng-container *ngIf="extraInfo$ | async as extraInfo">
  <vdr-card
    *ngIf="!this.detailForm.controls.customFields.value.freeGifts"
    [title]="'catalog.request-purchase-info' | translate"
    style="margin-bottom: 1rem"
  >
    <div class="form-grid">
      <vdr-form-field
        [label]="'catalog.total-request-purchase-amount' | translate"
      >
        {{ extraInfo.totalRequestPurchaseAmount }}
      </vdr-form-field>
    </div>
  </vdr-card>
</ng-container>
